const namespace = {
  scoresMenu: {
    header: {
      title: "Local Content",
      toggle: {
        ariaLabel: "Toggle scores menu",
        ariaLabel_open: "Open scores menu",
        ariaLabel_close: "Close scores menu",
      },
    },
  },
  categories: {
    transport: "Transport",
    amenities: "Amenities",
    character: "Character",
    nature: "Nature",
    education: "Education",
    wellness: "Wellness",
  },
  results: {
    none: "Sorry, there are no score results for this search within the specified radius around the selected location",
    limited: "Limited results for this search within a radius of",
  },
  commuteCalculator: {
    type: {
      pedestrian: "Walking",
      car: "Driving",
    },
    placeholder: "Search map...",
    cta: "Calculate commute",
    ctaShort: "Calculate",
    results: {
      noRoute: "No route available.",
      trySuggestion: "Try another query.",
      fastestRoute: "Fastest route",
    },
  },
  scores: {
    location: "This Location",
    average: "{{type}} Avg.",
    city: "City",
    neighborhood: "Neighborhood",
  },

  // Deprecate with LocalContentDeprecated
  tabs: {
    commute: "Transport",
    amenities: "Amenities",
    character: "Character",
    nature: "Nature",
    education: "Education",
    wellness: "Wellness",
  },
} as const;

export default namespace;
